export default __webpack_public_path__ + "static/media/avatar-s-4.a3d7af6b.jpg";